import './animated-section.component.scss';
import { PropsWithChildren, useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';
interface AnimatedSectionComponentProps extends PropsWithChildren {
  delay?: number;
  top?: string;
}
export const AnimatedSectionComponent = ({
  children,
  delay,
  top,
}: AnimatedSectionComponentProps) => {
  const { ref, inView } = useInView({
    /* Optional options */
    threshold: 0.4,
    triggerOnce: true,
    delay,
  });
  const [animateClassName, setAnimateClassName] = useState<string>();
  const [initialTop, setInitialTop] = useState<string>();
  useEffect(() => {
    setAnimateClassName(inView ? 'show' : 'hide');
    setInitialTop(inView ? undefined : top);
  }, [inView, top]);

  return (
    <div ref={ref}>
      <div
        style={{ top: initialTop }}
        className={`animated-wrapper ${animateClassName}`}
      >
        {children}
      </div>
    </div>
  );
};
export default AnimatedSectionComponent;
